const IMAGE_SIZE_INDEXES = {
  LARGE: 0,
  MEDIUM: 1,
  SMALL: 2,
};

export default IMAGE_SIZE_INDEXES;
